const NotFoundPage = () => {
  return (
    <div className="card">
      <h1 className="card-title">Seite nicht gefunden</h1>
      <p className="paragraph">
        Die angeforderte Seite existiert nicht. Bitte überprüfen Sie die URL oder wenden Sie sich an den
        Administrator.
      </p>
    </div>
  );
};

export default NotFoundPage;

